module.exports = require("@material-ui/core/Fade");